import styles from './index.module.scss';

const UserUsageStatusTag = ({ counts }) => {
  const refuelingCounts = counts.refueling ?? 1;
  const parkingCounts = counts.parking ?? 1;
  const onStreetParkingCounts = counts.onStreetParking ?? 1;
  if (refuelingCounts < 1 && parkingCounts < 1) {
    return <span className={styles.tag}>本月加油 / 停車名額已滿</span>;
  } else if (parkingCounts < 1) {
    return <span className={styles.tag}>本月停車名額已滿</span>;
  } else if (refuelingCounts < 1) {
    return <span className={styles.tag}>本月加油名額已滿</span>;
  } else if (onStreetParkingCounts < 1) {
    return <span className={styles.tag}>本月路停名額已滿</span>;
  } else {
    return null;
  }
};

export default UserUsageStatusTag;
